import type { BookableOptionId } from "./bookable-option-id";
import type { ManifestBookableOption } from "./manifest-bookable-option";

const isManifestBookableOption = (
    item:
        | {
              _id: BookableOptionId;
              _type: unknown;
          }
        | undefined
): item is ManifestBookableOption => {
    if (typeof item === "undefined") return false;
    return item._type === "MANIFEST_BOOKABLE_OPTION";
};

export { isManifestBookableOption };
